import { parse, format } from "date-fns";
import moment from "moment";
import ClearMask from "../components/InputMask/InputCurrentBRL/ClearMask";

export const parseAndFormatDate = (
  string: string,
  sourceFormat: string,
  destinationFormat: string,
): string | undefined => {
  try {
    return format(parse(string, sourceFormat, new Date()), destinationFormat);
  } catch {
    return undefined;
  }
};

export const removeNullKeys = (obj: any): any => {
  // eslint-disable-next-line no-restricted-syntax
  for (const key in obj) {
    if (obj[key] === null) {
      // eslint-disable-next-line no-param-reassign
      delete obj[key];
    }
  }

  return obj;
};

export const removeUndefinedKeys = (obj: any): any => {
  // eslint-disable-next-line no-restricted-syntax
  for (const key in obj) {
    if (obj[key] === undefined) {
      // eslint-disable-next-line no-param-reassign
      delete obj[key];
    }
  }

  return obj;
};

export function removeEmptyKeys<T>(obj: T): T {
  const newObj: T = {} as T;

  // eslint-disable-next-line no-restricted-syntax
  for (const key in obj) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    if (obj[key] !== "" && obj[key] !== undefined && obj[key] !== null) {
      newObj[key] = obj[key];
    }
  }

  return newObj;
}
